import {
  IonButton,
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonPage,
  IonSpinner
} from "@ionic/react";
import { close } from "ionicons/icons";
import { Form, Formik } from "formik";
// import { logoGoogle } from "ionicons/icons";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { getEmailValidationSchema } from "../components/forms/getValidationSchema";
import TextInput from "../components/forms/TextInput";
import validate from "../components/forms/validate";
import { signInWithEmail, signInWithGoogle } from "../lib/firebase";
import { useAuthStore } from "../stores/auth.store";

import googleicon from "../assets/graphics/Google_ G _Logo.svg";

const Auth: React.FC = () => {
  const [user, loading] = useAuthStore(state => [state.user, state.loading]);
  const history = useHistory();

  useEffect(() => {
    if (!loading && user) {
      history.replace("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading) {
    return (
      <div className="ion-text-center p-4">
        <IonSpinner />
      </div>
    );
  }

  const submitForm = async (values: any, { setSubmitting }: any) => {
    const { email } = values;
    const feedback = await signInWithEmail(email.trim(), "password");
    setSubmitting(false);
    console.log(feedback);
    if (feedback === "user-not-found") {
      history.push("/completeProfile", { email });
    } else if (feedback === "wrong-password") {
      history.push("/password", { email });
    }
  };

  return (
    <IonPage>
      <IonContent fullscreen>
        <IonFab
          className="mt-12 mb-12"
          vertical="top"
          horizontal="end"
          slot="fixed"
        >
          <IonFabButton
            color="PurpleBGBlackCross"
            onClick={() => history.goBack()}
          >
            <IonIcon icon={close} />
          </IonFabButton>
        </IonFab>
        <div className="max-w-lg mx-auto">
          <div className="font-base text-3xl mt-32 mx-6 mb-12">
            Login or Sign Up
          </div>
          <Formik
            initialValues={{ email: "" }}
            validate={validate(getEmailValidationSchema)}
            onSubmit={submitForm}
          >
            {({ isSubmitting, errors, isValid }) => (
              <Form className="mt-14">
                <div className="ml-6">Email</div>

                <TextInput
                  name="email"
                  label="Email:"
                  placeholder="Enter your email"
                  type="email"
                />
                <IonButton
                  expand="block"
                  color="primary"
                  type="submit"
                  className="mx-6 my-4 mb-10 h-12 normal-case"
                  disabled={isSubmitting || !isValid}
                >
                  Continue
                </IonButton>
              </Form>
            )}
          </Formik>

          <div className="flex gap-4 justify-center items-center m-6">
            <div className="flex-1 h-px bg-primary-50"></div>
            <div className="text-black-50">or</div>
            <div className="flex-1 h-px bg-primary-50"></div>
          </div>

          <IonButton
            expand="block"
            color="light"
            className="mx-6 h-[60px] normal-case relative"
            onClick={signInWithGoogle}
          >
            <IonIcon icon={googleicon} className="absolute left-4" />
            Continue with Google
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Auth;
